<div class="row filter-container">
  <div class="col-xs-12">
    <!-- SHOW FILTER BUTTON -->
    <div class="pull-right col-lg-4 col-md-5 col-sm-7 col-xs-12">
      <div class="row">
        <div class="col-xs-3 col-xs-offset-9">
          <button class="btn btn-outline-secondary" type="button" data-toggle="collapse" data-target="#filtres" aria-expanded="showFilters" aria-controls="filtres" (click)="showFilters = !showFilters">
            <span class="glyphico" [ngClass]="[showFilters ? 'glyphicon-minus' : 'glyphicon-plus']"></span>
            {{ 'COMMON.LABELS.FILTER'| translate }}
          </button>
        </div>
      </div>
    </div>
    <!-- FILTERS -->
    <div [class]="'col-xs-12 ' + collapse + ' formFilter'" id="filtres">
      <ng-content></ng-content>
    </div>
  </div>
</div>
